/**
 * How deep a row sits in the org trees, made visible: each level indents a
 * little further, and is shaded from dark to light blue down the hierarchy.
 * Asked for at the 6 Oct 2026 structure session, so a long reporting chain
 * reads at a glance: dark blue, then lighter blue, and indented a little more
 * to the right.
 */

/** Indentation per level, in pixels (it was 16). */
export const ORG_INDENT_PX = 24;

/** Literal class strings, so Tailwind keeps them; dark mode uses a lighter blue. */
const DEPTH_TINTS = [
  'bg-heritage-blue/[0.14] dark:bg-heritage-blue-300/[0.20]',
  'bg-heritage-blue/[0.09] dark:bg-heritage-blue-300/[0.13]',
  'bg-heritage-blue/[0.05] dark:bg-heritage-blue-300/[0.08]',
  'bg-heritage-blue/[0.025] dark:bg-heritage-blue-300/[0.04]',
] as const;

/** Left padding for a row at ``depth`` (0 = the top level). */
export const orgRowPadding = (depth: number): number => Math.max(0, depth) * ORG_INDENT_PX + 8;

/** Background tint for a row at ``depth``: darkest at the top; every level
 *  below the fourth keeps the lightest tint. */
export const orgRowTint = (depth: number): string =>
  DEPTH_TINTS[Math.min(Math.max(0, depth), DEPTH_TINTS.length - 1)];
